import { useEffect, useState } from "react"
import API from "../../../services/API"
import { LoadingButton } from "@mui/lab";
import { Stack } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import { txt } from "../../../services/translation";

export default function Download({section}){

    const [url, setUrl] = useState(null)
    const [downloading, setDownloading] = useState(false)

    useEffect(() => {

        API.get(`/study/sections/${section.id}/doc.html`)
            .then(r => {
                let blob = new Blob([r.data], {type: "text/html"});
                let url = window.URL.createObjectURL(blob);
                return setUrl( url )
            })
            .catch(e => console.log(e.response?.data))

        return () => {
            setUrl(null)
            setDownloading(false)
        }

    }, [section])

    const handleDownload = () => {
        API.download(`/study/sections/${section.id}/doc.zip`)
            .then(r => setDownloading(false))
            .catch(e => setDownloading(false))

        return setDownloading(true)
    }

    return <>

        {url && <iframe
            id={section.id}
            title={section.title}
            src={url} 
            width="100%"
            frameBorder="0"
            allow="autoplay; fullscreen"
        >
        </iframe>}
         
        <Stack direction='row' justifyContent='center'>

            <LoadingButton 
                variant='outlined' 
                onClick={handleDownload}
                loading={downloading}
                size='large'
                startIcon={<DownloadIcon />}
            >
                {txt('download')}
            </LoadingButton>

        </Stack>

    </>

}
